import {
  FETCHING_EXHIBITION_MODERATORS_REQUEST,
  FETCHING_EXHIBITION_MODERATORS_SUCCESS,
  FETCHING_EXHIBITION_MODERATORS_FAILURE,
} from '../actions/types';
import ResponseService from '../../utils/ResponseService';
import ApplicationError from '../../utils/ApplicationError';

const initialState = {
  moderators: [],
  error: ApplicationError.buildDefault(),
  isFetching: false,
  ...ResponseService.defaultPaginationMetaData()
};

const moderatorsReducer = (state = initialState, action ) => {
  switch(action.type) {

    // Get All Moderators
    case FETCHING_EXHIBITION_MODERATORS_REQUEST:
      return {...state, isFetching: true }
    case FETCHING_EXHIBITION_MODERATORS_SUCCESS:
      return {...state, isFetching: false, 
        moderators: action.payload.objects, 
        error: ApplicationError.buildDefault(),
        ...action.payload.paginationData }

    case FETCHING_EXHIBITION_MODERATORS_FAILURE:
      return {...state, isFetching: false, error: action.payload }
    
    default: 
      return state
  }
}

export default moderatorsReducer;